import * as Sentry from '@sentry/react'

import type { LoggerClient, LoggerContext } from 'clients/logger/interface'

type ErrorOptions = {
  error?: unknown
  context?: LoggerContext
}

export class SentryLogger implements LoggerClient {
  private readonly enabled: boolean

  constructor(enabled = Boolean(import.meta.env.VITE_SENTRY_DSN)) {
    this.enabled = enabled
  }

  info(message: string, context?: LoggerContext): void {
    if (!this.enabled) return

    Sentry.addBreadcrumb({
      level: 'info',
      category: 'app.logger',
      message,
      data: context,
    })
  }

  error(message: string, options?: ErrorOptions): void {
    if (!this.enabled) return

    Sentry.withScope((scope) => {
      scope.setLevel('error')
      scope.setTag('logger', 'sentry')
      scope.setContext('logger', {
        message,
        ...options?.context,
      })

      if (options?.error instanceof Error) {
        Sentry.captureException(options.error)
        return
      }

      Sentry.captureMessage(message, 'error')
    })
  }
}
